export default [
  {
    path: 'nickName',
    name: 'NickName',
    meta: {
      title: '新用户创建'
    },
    component: () =>
      import('../views/exerland/NickName.vue')
  },
  {
    path: 'hobby',
    name: 'Hobby',
    meta: {
      title: '爱好标签'
    },
    component: () =>
      import('../views/exerland/Hobby.vue')
  },
  {
    path: 'editNickName',
    name: 'EditNickName',
    meta: {
      title: '修改昵称'
    },
    component: () =>
      import(
        '../views/exerland/center/editNickName.vue'
      )
  },
  {
    path: 'editSignName',
    name: 'EditSignName',
    meta: {
      title: '修改签名'
    },
    component: () =>
      import(
        '../views/exerland/center/editSignName.vue'
      )
  }
]
